document.addEventListener("DOMContentLoaded", () => {
    const slidesContainer = document.querySelector(".bion-vendors__slides");
    if (slidesContainer === null) {
        return;
    }

    const showMoreButton = document.querySelector(".bion-vendors__show-more");
    const vendorsBg = document.querySelector(".bion-vendors__bg");
    const hiddenMobileSlides = document.querySelectorAll(".bion-vendors__slide--mobile-hidden");

    const showAllMobileSlides = () => {
        if(vendorsBg) {
            vendorsBg.classList.add("bion-vendors__bg_high");
        }

        hiddenMobileSlides.forEach((slide) => {
            slide.classList.remove("bion-vendors__slide--mobile-hidden");
        });

        if (showMoreButton) {
            showMoreButton.style.display = "none";
        }
    };

    if (showMoreButton && hiddenMobileSlides.length > 0) {
        showMoreButton.addEventListener("click", showAllMobileSlides);
    }

    const leftArrow = document.querySelector(".button-larrow");
    const rightArrow = document.querySelector(".button-rarrow");
    const progressBar = document.querySelector(".progress");
    const progressState = document.querySelector(".progress-state");

    // Ширина одного слайда
    const slideWidth = 320; // фиксированная ширина из вашего SCSS
    const gapWidth = 24; // расстояние между слайдами (12px с одной стороны)

    // Количество сдвига за 1 шаг (1.5 слайда)
    const scrollAmount = (slideWidth + gapWidth) * 1.5;

    // Обновить положение прогресс-бара
    const updateProgressState = () => {
        const scrollableWidth = slidesContainer.scrollWidth - slidesContainer.clientWidth;
        const scrollPercentage = slidesContainer.scrollLeft / scrollableWidth;
        const progressBarWidth = progressBar.offsetWidth - progressState.offsetWidth;

        // Передвижение progress-state
        progressState.style.transform = `translateX(${scrollPercentage * progressBarWidth}px)`;
    };

    // Функция для прокрутки влево
    const scrollLeft = () => {
        slidesContainer.scrollBy({
            left: -scrollAmount,
            behavior: "smooth",
        });
    };

    // Функция для прокрутки вправо
    const scrollRight = () => {
        slidesContainer.scrollBy({
            left: scrollAmount,
            behavior: "smooth",
        });
    };

    // Обработка клика на прогресс-баре
    const onProgressBarClick = (event) => {
        const progressBarWidth = progressBar.offsetWidth;
        const clickPosition = event.offsetX;
        const scrollableWidth = slidesContainer.scrollWidth - slidesContainer.clientWidth;

        const newScrollPosition = (clickPosition / progressBarWidth) * scrollableWidth;

        slidesContainer.scrollTo({
            left: newScrollPosition,
            behavior: "smooth",
        });
    };

    // Навешиваем обработчики событий
    leftArrow.addEventListener("click", scrollLeft);
    rightArrow.addEventListener("click", scrollRight);
    progressBar.addEventListener("click", onProgressBarClick);
    slidesContainer.addEventListener("scroll", updateProgressState);

    // Инициализация прогресс-бара
    updateProgressState();
});
